import { NodeViewWrapper } from '@tiptap/react';
import { useCallback } from 'react';

export default function ButtonLinkNodeView({ node, updateAttributes, selected }) {
  const edit = useCallback(() => {
    const href = window.prompt('URL', node.attrs.href || 'https://');
    if (href === null) return;
    const text = window.prompt('Button text', node.attrs.text || 'Button');
    if (text === null) return;
    updateAttributes({ href, text });
  }, [node.attrs, updateAttributes]);

  return (
    <NodeViewWrapper>
      <div className={`border-2 rounded transition-colors my-1 ${selected ? 'border-bahyellow' : 'border-transparent'}`}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          className="post-btn"
          href={node.attrs.href || '#'}
          onClick={e => { e.preventDefault(); edit(); }}
          title="Click to edit"
          style={{ cursor: 'pointer' }}
        >
          {node.attrs.text || 'Button'}
        </a>
      </div>
    </NodeViewWrapper>
  );
}
